<template>
    <div class="modal-content m-productPrices">
        <div class="modal-contentWrap">
            <div class="modal-header bg-1">
                <modal-close />
                <div class="modal-title text-center mb-0 mb-md-2">
                    <h2 class="h3 mb-1">
                        Ustaw cenę zestawu
                    </h2>
                    <h5 class="mb-0">Zestaw {{ setIdx + 1 }}</h5>
                </div>
            </div>
            <div class="modal-body p-4">
                <div
                    class="d-flex align-items-end flex-column gap-1 mb-3 pb-3 border-bottom"
                >
                    <div class="d-flex gap-0-5">
                        <money-input
                            class="mb-0"
                            style="width: 8.5rem"
                            :price="0"
                            :label="'Łączna cena za zestaw'"
                            @onChange="massPrice = $event"
                        ></money-input>
                        <the-btn
                            v-tooltip="'Zastosuj cenę do wszystkich sklepów'"
                            text="Zastosuj dla wszystkich"
                            @click.native="
                                onMassPromoSetPriceChange((+massPrice).toFixed(2))
                            "
                        />
                    </div>
                </div>
                <div>
                    <div class="c-table table-shop-products">
                        <div class="c-thead">
                            <div class="c-td is-1">Sklep</div>
                            <div class="c-td is-2">Łączna cena za zestaw</div>
                        </div>
                        <div class="c-tbody">
                            <div
                                class="t-shops-row py-1 px-3"
                                v-for="merchant in merchants"
                                :key="`merchant-${merchant.id}`"
                            >
                                <div class="c-td is-1">
                                    <h6 class="mb-0">
                                        {{ `${merchant.name}` }}
                                    </h6>
                                    {{ setShopAddress(merchant) }}
                                </div>
                                <div class="c-td is-2">
                                    <money-input
                                        class="mb-0"
                                        style="width: 6rem"
                                        :price="getSetPrice(merchant.id)"
                                        @onChange="onTempPromoSetPriceChange(merchant.id, $event)"
                                    ></money-input>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer" style="position: sticky; bottom: 0;">
                <the-btn
                    class="ml-auto"
                    text="Zapisz i zamknij"
                    @click.native="
                        saveChanges()
                        $store.dispatch('toggleModal', false)
                    "
                />
            </div>
        </div>
    </div>
</template>

<script>
import { addNewPromo } from '@/mixins/addNewPromo'
export default {
    name: 'ProductPrices',
    mixins: [addNewPromo],
    data() {
        return {
            massPrice: 0,
            equalPrices: false,
            tempSelectedProductSets: []
        }
    },
    created() {
        this.tempSelectedProductSets =
            JSON.parse(JSON.stringify(this.form.step3.product_sets[this.setIdx].price.value))
    },
    computed: {
        modalArgs() {
            return this.$store.getters.modalState.args
        },
        merchants() {
            return this.selectedMerchants
        },
        setIdx() {
            return this.modalArgs.setIdx
        }
    },
    methods: {
        getSetPrice(merchantId) {
            return this.tempSelectedProductSets.find(
                price => price.merchant_id === merchantId
            ).price
        },
        setShopAddress(data) {
            return this.$store.getters.getShopAddress(data)
        },
        onMassPromoSetPriceChange(price) {
            this.tempSelectedProductSets.forEach(setPrice => {
                this.$set(setPrice, 'price', price)
            })
        },
        saveChanges() {
            this.form.step3.product_sets[this.setIdx].price.value = this.tempSelectedProductSets
        },
        onTempPromoSetPriceChange(merchantId, price) {
            this.tempSelectedProductSets.find(
                price => price.merchant_id === merchantId
            ).price = price
        }
    }
}
</script>
